import _extends from "@babel/runtime/helpers/esm/extends";
/**
 * MuiTabs
 *
 * https://www.figma.com/file/gImnv1p0uOIizS33dnZJa9/Patient-App-2.0?node-id=698%3A52573&mode=dev
 */
const MuiTabs = {
  styleOverrides: {
    flexContainer: ({
      theme
    }) => ({
      background: theme.palette.grey[100],
      borderRadius: 12
    })
  }
};

/**
 * MuiTab
 *
 * https://www.figma.com/file/gImnv1p0uOIizS33dnZJa9/Patient-App-2.0?node-id=698%3A52573&mode=dev
 */
export const MuiTab = {
  styleOverrides: {
    root: ({
      theme
    }) => _extends({}, theme.typography.body2, {
      '&.Mui-selected': {
        borderRadius: 12,
        fontWeight: 600,
        background: theme.palette.common.white,
        border: `1px solid ${theme.palette.grey[100]}`,
        margin: '2px',
        outline: `2px solid ${theme.palette.primary.main}`
      }
    })
  }
};
export default MuiTabs;